import React, { useEffect, useState } from 'react';
import { fetchScannedItems } from '../../controllers/ResultsController';
import '../styles/ResultsPage.css';

function ResultsPage() {
  const [safeItems, setSafeItems] = useState([]);
  const [unsafeItems, setUnsafeItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getScannedItems = async () => {
      setLoading(true);
      setError(null); 

      try {
        const { safeItems, unsafeItems } = await fetchScannedItems();

        if (!Array.isArray(safeItems) || !Array.isArray(unsafeItems)) {
          throw new Error("Ugyldige scanningsdata modtaget.");
        }

        setSafeItems(safeItems);
        setUnsafeItems(unsafeItems);
      } catch (err) {
        console.error("Fejl ved hentning af scanningsdata:", err.message);
        setError(`Kunne ikke hente scanningsdata: ${err.message}`);
      } finally {
        setLoading(false);
      }
    };

    getScannedItems();
  }, []);

  return (
    <div className="results-container">
      <h2>Scannet Historik</h2>
      {loading && <p>Indlæser...</p>}
      {error && <p className="error-message">{error}</p>}
      {safeItems.length === 0 && unsafeItems.length === 0 && !loading && !error && (
        <p>Ingen scanningshistorik fundet.</p>
      )}
      <div className="results-section">
        <h3>Sikre Produkter</h3>
        <table className="results-table">
          <thead>
            <tr>
              <th>Produktnavn</th>
              <th>Ingredienser</th>
              <th>Kategorier</th>
              <th>Allergener</th>
              <th>Billede</th>
            </tr>
          </thead>
          <tbody>
            {safeItems.map((item, index) => (
              <tr key={`${item.code}-${index}`} className="safe-item">
                <td>{item.productName}</td>
                <td>{item.ingredientsList}</td>
                <td>{item.categories}</td>
                <td>{Array.isArray(item.detectedAllergens) ? item.detectedAllergens.join(', ') : item.detectedAllergens}</td>
                <td>{item.imageUrl ? <img src={item.imageUrl} alt="Product" className="product-image" /> : null}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="results-section">
        <h3>Usikre Produkter</h3>
        <table className="results-table">
          <thead>
            <tr>
              <th>Produktnavn</th>
              <th>Ingredienser</th>
              <th>Kategorier</th>
              <th>Allergener</th>
              <th>Billede</th>
            </tr>
          </thead>
          <tbody>
            {unsafeItems.map((item, index) => (
              <tr key={`${item.code}-${index}`} className="unsafe-item">
                <td>{item.productName}</td>
                <td>{item.ingredientsList}</td>
                <td>{item.categories}</td>
                <td>{Array.isArray(item.detectedAllergens) ? item.detectedAllergens.join(', ') : item.detectedAllergens}</td>
                <td>{item.imageUrl ? <img src={item.imageUrl} alt="Product" className="product-image" /> : null}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ResultsPage;